import React, { useEffect, useState } from "react";

import Chart from "react-apexcharts";
import ApexCharts from "apexcharts";
import styled from "@emotion/styled";

import { css } from "@emotion/react";
import { responsive } from "../../utils/style";

import { useReportMonk } from "../../context/reportMonk";
import { Dropdown, Button, Menu, Spin } from "antd";

import { CSVLink } from "react-csv";
import downloadIcon from "../../assets/icons/downloadBtnIcon.svg";
import useAuth from "../../utils/useAuth";
import { columns } from "./Table/columns";
import { fontFamiliy } from "./constant";

const getHeightMeasureText = (d) => {
  if (!d) return "-";
  if (d === "severe_stunted") return "เตี้ยแคระแกร็น";
  if (d === "stunted") return "เตี้ย";
  if (d === "relatively_stunted") return "ค่อนข้างเตี้ย";
  if (d === "normal") return "ตามเกณฑ์";
  if (d === "quite_high") return "ค่อนข้างสูง";
  if (d === "high") return "สูง";

  return "-";
};

const getWeightMeasureText = (d) => {
  if (!d) return "-";
  if (d === "severe_wasted") return "ผอมแห้ง";
  if (d === "wasted") return "ผอม";
  if (d === "relatively_wasted") return "ค่อนข้างผอม";
  if (d === "normal") return "สมส่วน";
  if (d === "buxom") return "ท้วม";
  if (d === "overweight") return "เริ่มอ้วน";
  if (d === "obese") return "อ้วน";

  return "-";
};

const getTableData = (dataTable, user) => {
  let csv = [];
  const { dataSource, sd, mean, median } = dataTable;
  if (user) {
    csv.push(
      [
        "ชื่อ",
        user.firstname,
        "นามสกุล",
        user.lastname,
        "ชื่อเล่น",
        user.nickname,
      ],
      [
        "ชื่อโรงเรียน",
        user.schoolName,
        "ชั้น",
        user.classNo,
        "ห้อง",
        user.roomNo,
      ]
    );
  }

  let totalWeeks = "-",
    startWeek = "-",
    endWeek = "-";

  if (Array.isArray(dataSource) && dataSource.length > 0) {
    totalWeeks = dataSource.length;
    startWeek = dataSource[0].week;
    endWeek = dataSource[dataSource.length - 1].week;
  }

  csv.push([
    "จำนวนข้อมูลที่กรอก",
    totalWeeks,
    "สัปดาห์",
    "ผลสัปดาห์ที่",
    startWeek,
    "ผลถึงสัปดาห์ที่",
    endWeek,
  ]);

  csv.push(columns.map((c) => c.title));

  if (Array.isArray(dataSource) && dataSource.length > 0)
    for (let i = 0; i < dataSource.length; ++i) {
      const d = dataSource[i];
      let csvRowData = [];

      for (let i = 0; i < columns.length; ++i) {
        if (columns[i].key === "rank") {
          if (d && d.rank && d.rank.allSchool)
            csvRowData.push(d.rank.allSchool);
          else {
            csvRowData.push("-");
          }
        } else if (
          Array.isArray(columns[i].dataIndex) &&
          columns[i].dataIndex[0] === "nutritionStatus"
        ) {
          if (d && d.nutritionStatus) {
            const { height, weight, heightForAge, weightForHeight } =
              d.nutritionStatus;
            csvRowData.push(
              height,
              weight,
              getHeightMeasureText(heightForAge),
              getWeightMeasureText(weightForHeight)
            );
          } else {
            csvRowData.push(null, null, null, null);
          }
          i += 3;
        } else if (
          columns[i].dataIndex === "rewards" &&
          Array.isArray(d.rewards)
        ) {
          csvRowData.push(d.rewards.join(","));
        } else {
          csvRowData.push(d[columns[i].dataIndex]);
        }
      }
      csv.push(csvRowData);
    }

  csv.push(getStatDataToCSV("ค่าเฉลี่ย", mean ? mean : "-"));
  csv.push(getStatDataToCSV("ส่วนเบี่ยงเบน มาตรฐาน", sd ? sd : "-"));
  csv.push(getStatDataToCSV("มัธยฐาน", median ? median : "-"));

  return csv;
};

const getStatDataToCSV = (name, data) => {
  const columnsShowInStats = columns.filter((c) => c.isShowInFooter);

  return [name, ...columnsShowInStats.map((c) => data[c.dataIndex])];
};

const ReportChart = () => {
  const {
    getChartData,
    getDataTable,
    chartView,
    chartOption,
    setChartYAxis,
    setChartOption,
  } = useReportMonk();

  const [isLoading, setIsLoading] = useState(false);

  const userInfo = useAuth();

  useEffect(() => {
    setChartYAxis(chartView);
  }, [chartView]);

  useEffect(() => {
    if (chartOption.title && chartOption.title.text !== "") {
      setTimeout(() => {
        const ac = ApexCharts.getChartByID("reportMonkChart");
        //ac.exports.exportToPng();
        setTimeout(() => {
          ac.dataURI({ width: 1500 }).then((v) => {
            console.log(v.imgURI);
            var a = document.createElement("a"); //Create <a>
            a.href = v.imgURI; //Image Base64 Goes here
            a.download = "Chart.png"; //File name Here
            a.click();
            a.remove();
          });
          setIsLoading(false);
        });
      }, 1000);
    }
  }, [chartOption.title]);

  const getChartTitle = (chartView) => {
    let type = "ข้อมูลคะแนน";

    switch (chartView) {
      case "cowMilkScore":
        type = `${type} ดื่มดี นมวัว`;
        break;
      case "vegetableScore":
        type = `${type} สุขชัวร์ เพิ่มผัก`;
        break;
      case "exerciseScore":
        type = `${type} รัก ออกกำลัง`;
        break;
      case "sweetDrinkScore":
        type = `${type} หยุดยั้ง น้ำหวาน`;
        break;

      default:
        type = `${type} รวมทั้ง 4 ด้าน`;
        break;
    }
    return `${type} ของสามเณร ${getMonkProfile("firstname")} ${getMonkProfile(
      "lastname"
    )} ${getMonkProfile("nickname")} ${getMonkProfile(
      "classNo"
    )} ${getMonkProfile("roomNo")} ${getMonkProfile("schoolName")}`;
  };

  const getMonkProfile = (dataType) => {
    let suffixText = "";
    if (dataType === "personalId") suffixText = "เลขที่";
    else if (dataType === "roomNo") suffixText = "ห้องเรียน";
    else if (dataType === "classNo") suffixText = "ชั้นเรียน";
    else if (dataType === "schoolName") suffixText = "โรงเรียน";
    else if (dataType === "nickname") suffixText = "ชื่อเล่น";
    else if (dataType === "firstname") suffixText = "ชื่อ";
    else if (dataType === "lastname") suffixText = "นามสกุล";

    return userInfo[dataType] ? `${suffixText} ${userInfo[dataType]}` : "";
  };

  const downloadChartPNG = async () => {
    setIsLoading(true);
    setChartOption({
      ...chartOption,
      chart: { ...chartOption.chart, width: "1144px" },
      title: {
        text: getChartTitle(chartView),
        align: "center",
        style: {
          fontSize: "16px",
          fontWeight: "bold",
          fontFamily: "Noto Sans Thai",
          color: "#058459",
        },
      },
    });

    setTimeout(() => {
      hideTitle();
    }, 2000);
  };

  const hideTitle = () => {
    setChartOption({
      ...chartOption,
      chart: { ...chartOption.chart, width: "100%" },
      title: {
        text: "",
      },
    });
  };

  const menu = (
    <Menu>
      <CSVLink
        data={getTableData(getDataTable(), userInfo)}
        filename={`reportMonk#${new Date().toDateString()}.csv`}
        key={"ReportMonkCSVs"} // for disable warning in console
      >
        <Menu.Item key={"menuDownloadCSVMonk"}>ตาราง (CSV)</Menu.Item>
      </CSVLink>
      <Menu.Item key={"menuDownloadChartMonk"} onClick={downloadChartPNG}>
        แผนภูมิ (Chart)
      </Menu.Item>
    </Menu>
  );

  const ChartContainer = styled.div`
    margin-top: 16px;
    max-width: 1144px;
    width: ${chartOption.chart.width};
    padding-left: 10%;
    padding-right: 10%;

    ${responsive.mobile(css`
      //max-width: 375px;
      padding-left: 0px;
      padding-right: 8px;
    `)}
  `;

  return (
    <ChartContainer>
      <Spin spinning={isLoading}>
        <Chart
          options={chartOption}
          series={getChartData()}
          type="scatter"
          height={450}
          width={chartOption.width}
        />
        <Dropdown overlay={menu} placement="topLeft" arrow>
          <DownloadBtn>
            {" "}
            <img src={downloadIcon} style={{ marginRight: "8px" }} />
            ดาวน์โหลด
          </DownloadBtn>
        </Dropdown>
      </Spin>
    </ChartContainer>
  );
};

const DownloadBtn = styled(Button)`
  cursor: pointer;
  font-family: ${fontFamiliy}
  font-style: normal;
  font-weight: 600;
  font-size: 19px;
  line-height: 23px;
  /* identical to box height, or 121% */

  letter-spacing: -0.02em;

  /* Primary/Green 400 */

  color: #16af7b;
  padding: 14px 32px 32px;

  /* Primary/Green 50 */

  background: #b5f6df;
  /* Primary/Green 400 */

  border: 1px solid #16af7b;
  border-radius: 100px;
  float: right;

  :hover,
  :focus,
  :active {
    border: 1px solid #16af7b;
    color: #16af7b;
    background: #b5f6df;
  }
`;

export default ReportChart;
